import { RootState } from "@/modules/common";

export const selectIsLoadingBasket = (state: RootState) =>
  state.basket.status === "loading";
